import { IUserRepository } from "@/core/repositories/user";

export class GetUserAccessTokenUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(): Promise<string | null> {
    const userAccessToken = await this.userRepository.getUserAccessToken();
    return userAccessToken?.accessToken ?? null;
  }
}
